<div
  class="activity-report-mgmt flex flex-col min-h-[calc(100vh-100px)] w-full bg-[#F7FAFC] font-['Archivo',sans-serif] px-[24px] md:px-[32px] lg:px-[40px] pt-[24px] pb-[32px] relative">
  <div *ngIf="isInitialLoading" class="flex flex-col items-center justify-center w-full py-[80px] gap-4">
    <div class="loader-spinner w-12 h-12 border-4 border-[#f26f24ff] border-t-transparent rounded-full animate-spin"></div>
    <span class="text-[#111215] text-[18px]">Loading...</span>
  </div>

  <ng-container *ngIf="!isInitialLoading">
    <div
      class="activity-report-mgmt__panel w-full bg-white rounded-[12px] border border-[#EAECF0] shadow-[0_1px_3px_rgba(16,24,40,0.08),0_1px_2px_rgba(16,24,40,0.06)] p-[24px] flex flex-col gap-[20px]">
      <div class="flex flex-row flex-wrap items-center justify-between gap-[16px]">
        <div class="flex flex-row flex-wrap items-center gap-[16px]">
          <button
            type="button"
            class="inline-flex items-center justify-center gap-[8px] box-border h-[44px] px-[16px] rounded-[16px] border border-[#D0D5DD] bg-white text-[#101828] text-[16px] font-semibold leading-[20px] cursor-pointer hover:bg-[#F9FAFB]"
            (click)="goBack()"
            aria-label="Back">
            <svg
              class="w-5 h-5 shrink-0"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true">
              <path
                d="M20 12H4M4 12L10 18M4 12L10 6"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
            <span>Back</span>
          </button>
          <h1 class="text-[#111215] font-bold text-[24px] leading-[32px] tracking-[-0.01em] m-0">
            Activity Report
          </h1>

          <div class="activity-report-mgmt__mode-toggle" role="group" aria-label="Activity report mode">
            <button
              type="button"
              class="activity-report-mgmt__mode-btn"
              [class.activity-report-mgmt__mode-btn--active]="reportMode === 'booked'"
              (click)="setReportMode('booked')">
              Booked
            </button>
            <button
              type="button"
              class="activity-report-mgmt__mode-btn"
              [class.activity-report-mgmt__mode-btn--active]="reportMode === 'delivered'"
              (click)="setReportMode('delivered')">
              Delivered
            </button>
          </div>
        </div>

        <div class="flex flex-row flex-wrap items-center gap-[10px] justify-end">
          <!-- Figma: date dropdowns show "08 Aug 2026"; default both to today -->
          <label class="sr-only" for="activity-report-from">From date</label>
          <div
            class="activity-report-mgmt__date-wrap"
            role="button"
            tabindex="0"
            (click)="openDatePicker($event)"
            (keydown.enter)="openDatePicker($event)"
            (keydown.space)="$event.preventDefault(); openDatePicker($event)">
            <span class="activity-report-mgmt__date-label" aria-hidden="true">
              {{ formatDatePickerLabel(customFromDate) }}
            </span>
            <input
              id="activity-report-from"
              type="date"
              class="activity-report-mgmt__date-input"
              [(ngModel)]="customFromDate"
              (click)="openDatePicker($event); $event.stopPropagation()"
              (ngModelChange)="onFiltersChanged()" />
          </div>

          <label class="sr-only" for="activity-report-to">To date</label>
          <div
            class="activity-report-mgmt__date-wrap"
            role="button"
            tabindex="0"
            (click)="openDatePicker($event)"
            (keydown.enter)="openDatePicker($event)"
            (keydown.space)="$event.preventDefault(); openDatePicker($event)">
            <span class="activity-report-mgmt__date-label" aria-hidden="true">
              {{ formatDatePickerLabel(customToDate) }}
            </span>
            <input
              id="activity-report-to"
              type="date"
              class="activity-report-mgmt__date-input"
              [(ngModel)]="customToDate"
              (click)="openDatePicker($event); $event.stopPropagation()"
              (ngModelChange)="onFiltersChanged()" />
          </div>

          <label class="sr-only" for="activity-report-center">Center</label>
          <select
            id="activity-report-center"
            class="activity-report-mgmt__select activity-report-mgmt__toolbar-control h-[40px] min-w-[160px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] pr-[36px] outline-none focus:border-[#F26F24] cursor-pointer"
            [(ngModel)]="filterCenterName"
            (ngModelChange)="onFiltersChanged()">
            <option value="">All Centers</option>
            <option *ngFor="let center of centers" [value]="center.locationName">
              {{ center.locationName }}
            </option>
          </select>

          <button
            type="button"
            class="activity-report-mgmt__filter-icon-btn inline-flex items-center justify-center h-[40px] w-[40px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#737780] cursor-pointer hover:bg-[#F9FAFB]"
            (click)="openFilterPanel()"
            aria-label="Filter">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path
                d="M4 5h16l-6.5 7.5V19l-3 1.5v-8L4 5z"
                stroke="currentColor"
                stroke-width="1.75"
                stroke-linejoin="round" />
            </svg>
          </button>

          <button
            type="button"
            class="activity-report-mgmt__toolbar-control inline-flex items-center gap-[8px] h-[40px] px-[14px] rounded-[8px] border border-[#D0D5DD] bg-white cursor-pointer hover:bg-[#F9FAFB] disabled:opacity-50 disabled:cursor-not-allowed"
            (click)="onDownload()"
            [disabled]="!rows.length">
            <img src="assets/icons/download.svg" alt="" class="w-[16px] h-[16px]" />
            Download
          </button>
        </div>
      </div>

      <div *ngIf="errorMessage" class="text-red-600 text-[14px]">
        {{ errorMessage }}
      </div>

      <div *ngIf="isRefreshing" class="text-[#667085] text-[13px]">Updating…</div>

      <div class="activity-report-mgmt__table w-full overflow-x-auto">
        <table *ngIf="!errorMessage" class="w-full border-collapse min-w-full">
          <thead>
            <tr>
              <th scope="col" class="text-left">User Name</th>
              <th scope="col" class="text-left">Activity</th>
              <th scope="col" class="text-left">Type</th>
              <th *ngIf="showProvidedBy" scope="col" class="text-left">Provided by</th>
              <th scope="col" class="text-left">Center</th>
              <th scope="col" class="text-left">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="!rows.length">
              <td
                class="text-center text-[#667085] text-[18px] font-medium py-[40px]"
                [attr.colspan]="showProvidedBy ? 6 : 5">
                No activity participation found for this period.
              </td>
            </tr>
            <tr *ngFor="let row of rows; trackBy: trackByRow">
              <td class="text-left whitespace-nowrap">{{ row.userName }}</td>
              <td class="text-left whitespace-nowrap">{{ row.activity }}</td>
              <td class="text-left whitespace-nowrap">{{ row.type }}</td>
              <td *ngIf="showProvidedBy" class="text-left whitespace-nowrap">{{ row.providedBy }}</td>
              <td class="text-left whitespace-nowrap">{{ row.center }}</td>
              <td class="text-left whitespace-nowrap">{{ formatDate(row.participatedAt) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>

  <!-- Figma filter side panel -->
  <div
    *ngIf="isFilterPanelOpen"
    class="fixed inset-0 z-40 flex justify-end bg-black/20"
    (click)="closeFilterPanel()">
    <aside
      class="activity-report-mgmt__filter-panel h-full w-full max-w-[360px] bg-white shadow-[-8px_0_24px_rgba(16,24,40,0.12)] flex flex-col"
      (click)="$event.stopPropagation()"
      role="dialog"
      aria-label="Filter">
      <div class="flex items-center justify-between px-[24px] pt-[24px] pb-[16px] border-b border-[#EAECF0]">
        <h2 class="m-0 text-[#111215] font-bold text-[20px] leading-[28px]">Filter</h2>
        <button
          type="button"
          class="h-[32px] w-[32px] rounded-[8px] border-0 bg-transparent text-[#667085] text-[20px] cursor-pointer hover:bg-[#F2F4F7]"
          (click)="closeFilterPanel()"
          aria-label="Close filter">
          ×
        </button>
      </div>

      <div class="flex-1 overflow-y-auto px-[24px] py-[20px] flex flex-col gap-[16px]">
        <label class="flex flex-col gap-[6px] text-[14px] font-medium text-[#344054]">
          Activity
          <select
            class="activity-report-mgmt__select h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] pr-[36px] text-[14px] text-[#333740] outline-none focus:border-[#F26F24] cursor-pointer"
            [(ngModel)]="draftActivityName">
            <option value="">Select</option>
            <option *ngFor="let activity of activityOptions" [value]="activity">{{ activity }}</option>
          </select>
        </label>

        <label class="flex flex-col gap-[6px] text-[14px] font-medium text-[#344054]">
          Activity Type
          <select
            class="activity-report-mgmt__select h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] pr-[36px] text-[14px] text-[#333740] outline-none focus:border-[#F26F24] cursor-pointer"
            [(ngModel)]="draftActivityType">
            <option value="">Select</option>
            <option *ngFor="let type of activityTypeOptions" [value]="type">{{ type }}</option>
          </select>
        </label>

        <label
          *ngIf="showProvidedBy"
          class="flex flex-col gap-[6px] text-[14px] font-medium text-[#344054]">
          Provided by
          <select
            class="activity-report-mgmt__select h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] pr-[36px] text-[14px] text-[#333740] outline-none focus:border-[#F26F24] cursor-pointer"
            [(ngModel)]="draftProvidedBy">
            <option value="">Select</option>
            <option *ngFor="let provider of providedByOptions" [value]="provider">{{ provider }}</option>
          </select>
        </label>

        <label class="flex flex-col gap-[6px] text-[14px] font-medium text-[#344054]">
          Center
          <select
            class="activity-report-mgmt__select h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] pr-[36px] text-[14px] text-[#333740] outline-none focus:border-[#F26F24] cursor-pointer"
            [(ngModel)]="draftCenterName">
            <option value="">Select</option>
            <option *ngFor="let center of centers" [value]="center.locationName">
              {{ center.locationName }}
            </option>
          </select>
        </label>

        <div class="flex flex-col gap-[6px] text-[14px] font-medium text-[#344054]">
          Date Range
          <div class="flex flex-col gap-[8px]">
            <input
              type="date"
              class="h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] text-[14px] text-[#333740] outline-none focus:border-[#F26F24]"
              [(ngModel)]="draftFromDate"
              aria-label="From date" />
            <input
              type="date"
              class="h-[44px] rounded-[8px] border border-[#D0D5DD] bg-white px-[12px] text-[14px] text-[#333740] outline-none focus:border-[#F26F24]"
              [(ngModel)]="draftToDate"
              aria-label="To date" />
          </div>
        </div>
      </div>

      <div class="flex flex-row gap-[12px] px-[24px] py-[20px] border-t border-[#EAECF0]">
        <button
          type="button"
          class="flex-1 h-[48px] rounded-[8px] border border-[#D0D5DD] bg-white text-[#344054] text-[16px] font-semibold cursor-pointer hover:bg-[#F9FAFB]"
          (click)="resetFilterPanel()">
          Reset
        </button>
        <button
          type="button"
          class="flex-1 h-[48px] rounded-[8px] border-0 bg-[#F26F24] text-white text-[16px] font-semibold cursor-pointer hover:bg-[#E05F14]"
          (click)="applyFilterPanel()">
          APPLY
        </button>
      </div>
    </aside>
  </div>
</div>
